var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "billing-view-container" },
    [
      _c("div", { staticClass: "filters-section" }, [
        _c("div", { staticClass: "filters-header" }, [
          _c(
            "h3",
            { staticClass: "filters-title" },
            [
              _c("feather-icon", {
                attrs: { icon: "SlidersIcon", svgClasses: "w-4 h-4" },
              }),
              _vm._v("\n        Filtros\n      "),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "filters-inline-row" }, [
          _c(
            "div",
            { staticClass: "filter-item" },
            [
              _vm._m(0),
              _c("holding-select", {
                ref: "holdingSelect",
                on: {
                  value: function ($event) {
                    _vm.filters.holdings = $event
                  },
                  companies: function ($event) {
                    _vm.companies = $event
                  },
                  clearCompanies: _vm.clearCompanies,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "filter-item" },
            [
              _vm._m(1),
              _c("companies-select", {
                ref: "companiesSelect",
                attrs: { companies: _vm.companies },
                on: {
                  value: function ($event) {
                    _vm.filters.companies = $event
                  },
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "filter-item filter-item--xs" }, [
            _c("label", { staticClass: "filter-label" }, [
              _vm._v("ID Campaña"),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filters.campaignId,
                  expression: "filters.campaignId",
                },
              ],
              staticClass: "filter-input",
              attrs: { type: "text", placeholder: "ID" },
              domProps: { value: _vm.filters.campaignId },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filters, "campaignId", $event.target.value)
                },
              },
            }),
          ]),
          _c("div", { staticClass: "filter-item filter-item--sm" }, [
            _c("label", { staticClass: "filter-label" }, [_vm._v("Estado")]),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filters.status,
                    expression: "filters.status",
                  },
                ],
                staticClass: "filter-native-select",
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.filters,
                      "status",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                },
              },
              [
                _c("option", { attrs: { value: "unbilled" } }, [
                  _vm._v("No facturado"),
                ]),
                _c("option", { attrs: { value: "billed" } }, [
                  _vm._v("Facturado"),
                ]),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "filter-item" },
            [
              _c("label", { staticClass: "filter-label" }, [
                _vm._v("Fecha de vencimiento"),
              ]),
              _c("flat-pickr", {
                staticClass: "date-picker",
                attrs: {
                  width: "100%",
                  config: _vm.configDateRangeCampaignsTimePicker,
                  placeholder: "Desde - Hasta",
                },
                on: { "on-close": _vm.onDateRangeCampaignsChange },
                model: {
                  value: _vm.dateRange,
                  callback: function ($$v) {
                    _vm.dateRange = $$v
                  },
                  expression: "dateRange",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "filter-actions" }, [
            _c("div", { staticClass: "filter-label-spacer" }),
            _c(
              "div",
              { staticClass: "filter-buttons" },
              [
                _c(
                  "vs-button",
                  {
                    staticClass: "search-btn",
                    attrs: { color: "primary" },
                    on: { click: _vm.searchData },
                  },
                  [_vm._v("Buscar")]
                ),
                _c(
                  "vs-button",
                  {
                    staticClass: "clear-btn",
                    attrs: { type: "border" },
                    on: { click: _vm.clearFilters },
                  },
                  [_vm._v("Limpiar")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("billing-table", {
        ref: "campaignsBilling",
        attrs: { filters: _vm.filters },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "filter-label" }, [
      _vm._v("Holding "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "filter-label" }, [
      _vm._v("Cliente "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }